
   import PolicyMenu from '@/components/core/PolicyMenu';
  export default {
    layout:'rules',
    components: {
      PolicyMenu
    },
    scrollToTop: true,
    head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          }
        ],
      }
    },
    data() {
      return {
        title: 'Refund & Cancellation '
      }
    },

  }

